import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ProductLabelModule } from "../product-label/product-label.module";
import ProductCardInfoComponent from './product-card-info.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ProductLabelModule
  ],
  exports: [ProductCardInfoComponent],
  declarations: [ProductCardInfoComponent],
})
export class ProductCardInfoModule {
}
